import { formatApplicantsNames } from '../../../utils/formatLogicUtil';

export const applicationApprovedHeader = 'Application approved';
export const approveApplicationHeader = 'Approve application';

export const itmiHeader = 'Invite to Move In';

export function getHasMultipleApplicants(applicants) {
  return applicants.length > 1;
}

export function getDefaultInvitationText({ applicants, contactName, street }) {
  const isMultipleApplicants = getHasMultipleApplicants(applicants);
  const formattedNames = formatApplicantsNames({ applicants, defaultText: 'there' });
  return `Hi ${formattedNames},\n\nI have reviewed your application${
    isMultipleApplicants ? 's' : ''
  }, and it would be great to have you as ${
    isMultipleApplicants ? 'tenants' : 'a tenant'
  } at ${street}. You can expect an electronic lease from me in a few hours. Once you've received that document, let's coordinate a time to talk and discuss next steps.\n\nCongrats!\n${contactName}`;
}
